var lightbox = new SimpleLightbox(".gallery a", {
});

//# sourceMappingURL=gallery_us.ea844051.js.map
